var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.635 1.36992C12.6408 0.723697 11.3592 0.723698 10.365 1.36992L2.36503 6.56992C1.51366 7.12332 1 8.06983 1 9.08525V19.9999C1 21.6567 2.34315 22.9999 4 22.9999H20C21.6569 22.9999 23 21.6567 23 19.9999V9.08525C23 8.06983 22.4863 7.12332 21.635 6.56992L13.635 1.36992ZM11.455 3.04681C11.7864 2.8314 12.2136 2.8314 12.545 3.04681L20.545 8.24681C20.8288 8.43128 21 8.74678 21 9.08525V19.9999C21 20.5522 20.5523 20.9999 20 20.9999H15.9998L16 13.4614C16 11.3738 14.0151 9.99988 12.0001 9.99988C9.98507 9.99988 8.00017 11.3738 8.00016 13.4614L8 20.9999L9.18182 20.9999H4C3.44772 20.9999 3 20.5522 3 19.9999V9.08525C3 8.74678 3.17122 8.43128 3.45501 8.24681L11.455 3.04681ZM10 20.9999H15.1817L13.9998 20.9999L14 13.4614C14 12.8301 13.2987 11.9999 12.0001 11.9999C10.7015 11.9999 10.0002 12.8301 10.0002 13.4614L10 20.9999Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ed59c7769e187166478d4d5eb85df14c.svg";
export { ForwardRef as ReactComponent };